import { render, staticRenderFns } from "./ComunicacionBaja.vue?vue&type=template&id=ca139bbc&"
import script from "./ComunicacionBaja.vue?vue&type=script&lang=js&"
export * from "./ComunicacionBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports